	import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'ConfirmComponent',
	templateUrl: 'ConfirmComponent.html',
    
})
export class ConfirmComponent {
  
	constructor(
		private activeModal: NgbActiveModal,
		) {
		
	}

	@Input() public message: string = "";
	
	cancel(result: boolean) {
		this.activeModal.close(result);
	}
}
